import { FC, InputHTMLAttributes, forwardRef, useEffect, useRef } from "react";
import { TextField } from "@mui/material";

interface IInputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  search?: string;
  focused?: boolean;
}

export const InputField: FC<IInputFieldProps> = forwardRef(
  ({ type = "text", placeholder, search, focused = false, ...props }, ref) => {
    const inputRef = useRef();

    useEffect(() => {
      const timeout = setTimeout(() => {
        inputRef?.current?.focus();
      }, 100);

      return () => {
        clearTimeout(timeout);
      };
    }, []);

    return (
      <TextField
        {...props}
        value={search}
        sx={{ width: "95%", caretColor: focused ? "" : "Transparent" }}
        type={type}
        inputRef={focused ? inputRef : ref}
        color={"primary"}
        size="small"
        variant="outlined"
        placeholder={placeholder}
        fullWidth
        focused={focused}
      />
    );
  },
);
